import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useQuery } from "@tanstack/react-query";

import { getAdminPracticeOrganicFertilizerApplications, getPracticeOrganicFertilizerApplications } from "services";

import { getEnvironment, injectNames } from "utils";

import { DEFAULT_CACHE_TIME, GET_PRACTICES_FERTILIZERS_APPLICATIONS } from "consts";

import { PracticeFertilizerApplication } from "models";

const env = getEnvironment();

export const useGetPracticeOrganicFertilizerApplications = ({ enabled, isAdmin = env.admin }: { enabled?: boolean; isAdmin?: boolean }) => {
  // Not having { useSuspense: false } caused unintended UI behavior — like a drawer opening and closing on mount,
  // due to remounting triggered by Suspense fallback.
  // DO NOT REMOVE unless you're explicitly handling Suspense with fallback UIs.
  const { t } = useTranslation("practices", { useSuspense: false });

  const queryFn = isAdmin ? getAdminPracticeOrganicFertilizerApplications : getPracticeOrganicFertilizerApplications;

  // Translate in select, not queryFn, so the cached data stays language-neutral and names follow language and namespace loads.
  const withTranslatedNames = useCallback((applications: PracticeFertilizerApplication[]) => injectNames(applications, t, "fertilizerApplications"), [t]);

  return useQuery({
    queryKey: [GET_PRACTICES_FERTILIZERS_APPLICATIONS, enabled],
    queryFn: () => queryFn({ enabled }),
    select: withTranslatedNames,
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
